import { createComponent } from '@carvana/merch-components';

export const VehicleLinkCardContainer = createComponent('a', {
  className:
    'grid w-full grid-cols-[minmax(0,_1fr)_90px] items-center gap-xl overflow-hidden sm:min-h-[103px] md:grid-cols-[minmax(0,_1fr)_140px]'
});

export const InformationContainer = createComponent('div', {
  className: 'flex flex-col gap-sm overflow-hidden'
});

export const VehicleYearMakeModel = createComponent('p', {
  className: 'truncate text-text-strong t-heading-sm'
});

export const VehicleTrim = createComponent('p', {
  className: 'truncate text-text-default t-body-sm '
});

export const VehiclePrice = createComponent('span', {
  className: 'text-text-strong t-heading-sm'
});

export const ThumbnailContainer = createComponent('div', {
  className: 'relative w-[90px] md:w-[140px]'
});
